import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/auth/auth.guard';
import { ViewEmrDetailsComponent } from './pages/view-emr-details/view-emr-details.component';
import { selectedPatientGuard } from './services/auth/selected-patient-guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'book-consultation',
    canActivate: [AuthGuard, selectedPatientGuard],
    loadChildren: () =>
      import('./pages/book-consultation/book-consultation.module').then(
        (m) => m.BookConsultationPageModule
      ),
  },
  {
    path:'emr-details/:visitId',
    canActivate: [AuthGuard, selectedPatientGuard],
    component: ViewEmrDetailsComponent
  },
    {
    path: 'self-register',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/self-register/self-register.module').then((s) => s.SelfRegisterModule)
  },
  {
    path: 'my-uploads',
    canActivate: [AuthGuard, selectedPatientGuard],
    loadChildren: () => import('./pages/my-uploads/my-upload.module').then(m => m.MyUploadsModule)
  },
  {
    path: 'view-appointment',
    canActivate: [AuthGuard, selectedPatientGuard],
    loadChildren: () =>
      import('./pages/view-appointment/view-appointment.module').then(
        (m) => m.ViewAppointmentPageModule
      ),
  },
  {
    path: 'prescriptions',
    canActivate: [AuthGuard, selectedPatientGuard],
    loadChildren: () =>
      import('./pages/prescriptions/prescriptions.module').then(
        (m) => m.PrescriptionsPageModule
      ),
  },
  {
    path: 'patient-list',
    loadChildren: () =>
      import('./pages/patient-list/patient-list.module').then(
        (m) => m.PatientListPageModule
      ),
  },
  {
    path: 'visit-info',
    canActivate: [AuthGuard, selectedPatientGuard],
    loadChildren: () =>
      import('./pages/visit-info/visit-info.module').then(
        (m) => m.VisitInfoPageModule
      ),
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
